import { z } from 'zod';
import { ClaimNumberSchema, InitialClaimActionsSchema } from '../model/index.js';
import { BaseHeaderSchema } from './base.js';
const RemoveInitialClaimActionsSchemas = {
    params: z.object({
        claimNumber: ClaimNumberSchema,
    }),
    body: z.object({
        initialClaimActions: InitialClaimActionsSchema.array(),
    }),
    headers: BaseHeaderSchema,
    response: z.object({
        claimNumber: ClaimNumberSchema,
        initialClaimActions: InitialClaimActionsSchema.array(),
    }),
};
export const RemoveInitialClaimActionsRequestSchema = RemoveInitialClaimActionsSchemas.params
    .merge(RemoveInitialClaimActionsSchemas.body)
    .merge(RemoveInitialClaimActionsSchemas.headers);
export const RemoveInitialClaimActionsApiSchema = RemoveInitialClaimActionsSchemas;
